import {
  LIBRARY_MODIFIER_HUB_PAGE_REQUEST,
  LIBRARY_MODIFIER_HUB_ON_CLICK_CREATE_MODIFIER,
  LIBRARY_MODIFIER_HUB_SET_MODIFIERS,
  LIBRARY_MODIFIER_HUB_SET_META_MODIFIERS,
  LIBRARY_MODIFIER_HUB_ON_CLICK_ROW,
  LIBRARY_MODIFIER_HUB_SET_MODIFIER_DETAIL,
  LIBRARY_MODIFIER_HUB_REQUEST_MODIFIERS,
  LIBRARY_MODIFIER_HUB_ON_CLICK_CANCEL,
  LIBRARY_MODIFIER_HUB_SUBMIT_FORM_CREATE,
  LIBRARY_MODIFIER_HUB_SUBMIT_FORM_UPDATE,
  LIBRARY_MODIFIER_HUB_DELETE_MODIFIER,
  LIBRARY_MODIFIER_HUB_SHOW_DELETE_MODIFIER_MODAL,
  LIBRARY_MODIFIER_HUB_HIDE_DELETE_MODIFIER_MODAL,
  LIBRARY_MODIFIER_HUB_SET_DELETED_MODIFIER,
  LIBRARY_MODIFIER_HUB_ON_CLICK_APPLY_SET_ITEM,
  LIBRARY_MODIFIER_HUB_SHOW_APPLY_SET_ITEM_MODAL,
  LIBRARY_MODIFIER_HUB_HIDE_APPLY_SET_ITEM_MODAL,
  LIBRARY_MODIFIER_HUB_APPLY_SET_ITEM_SET_ITEMS,
  LIBRARY_MODIFIER_HUB_APPLY_SET_ITEM_SET_META,
  LIBRARY_MODIFIER_HUB_SHOW_MODIFIER_OPTIONS_MODAL,
  LIBRARY_MODIFIER_HUB_HIDE_MODIFIER_OPTIONS_MODAL,
  LIBRARY_MODIFIER_HUB_CONFIRM_APPLY_SET_ITEM,
  LIBRARY_MODIFIER_HUB_ON_CLICK_MANAGE_MODIFIER_OPTIONS,
  LIBRARY_MODIFIER_HUB_ON_CANCEL_MANAGE_MODIFIER_OPTIONS,
  LIBRARY_MODIFIER_HUB_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS,
  LIBRARY_MODIFIER_HUB_SET_PREVIOUS_MODIFIER_FORM,
  LIBRARY_MODIFIER_HUB_OPEN_RIGHT_COLUMN,
  LIBRARY_MODIFIER_HUB_CLOSE_RIGHT_COLUMN,
  LIBRARY_MODIFIER_HUB_IS_SUBMITTING_FORM,
  LIBRARY_MODIFIER_HUB_SET_ALL_ITEM_CONFIRMATION_MODAL_OPEN,
  LIBRARY_MODIFIER_HUB_SET_ALL_ITEM_CONFIRMATION_MODAL_CLOSE,
  LIBRARY_MODIFIER_HUB_ON_CLICK_APPLY_ALL_ITEMS,
  LIBRARY_MODIFIER_HUB_SET_MODIFIER_ALL_ITEMS,
  LIBRARY_MODIFIER_HUB_SET_CHANNEL_ASYNC_JOB,
  LIBRARY_MODIFIER_HUB_HANDLE_SUCCESS_ASYNC_JOB,
  LIBRARY_MODIFIER_HUB_HANDLE_FAILED_ASYNC_JOB,
  LIBRARY_MODIFIER_HUB_APPLY_SET_ITEM_ITEMS_REQUEST,
} from './constants';

export function pageRequest() {
  return { type: LIBRARY_MODIFIER_HUB_PAGE_REQUEST };
}

export function modifiersRequest(params, previousModifiers) {
  return {
    type: LIBRARY_MODIFIER_HUB_REQUEST_MODIFIERS,
    payload: { params, previousModifiers },
  };
}

export function onClickCreateModifier() {
  return { type: LIBRARY_MODIFIER_HUB_ON_CLICK_CREATE_MODIFIER };
}

export function onClickRow(modifier) {
  return { type: LIBRARY_MODIFIER_HUB_ON_CLICK_ROW, payload: { modifier } };
}

export function onClickCancel() {
  return { type: LIBRARY_MODIFIER_HUB_ON_CLICK_CANCEL };
}

export function setModifiers(modifiers) {
  return { type: LIBRARY_MODIFIER_HUB_SET_MODIFIERS, payload: { modifiers } };
}

export function setMetaModifier(meta) {
  return { type: LIBRARY_MODIFIER_HUB_SET_META_MODIFIERS, payload: { meta } };
}

export function setModifierDetail(modifier) {
  return {
    type: LIBRARY_MODIFIER_HUB_SET_MODIFIER_DETAIL,
    payload: { modifier },
  };
}

export function submitFormCreate(data, previousModifiers) {
  return {
    type: LIBRARY_MODIFIER_HUB_SUBMIT_FORM_CREATE,
    payload: { data, previousModifiers },
  };
}

export function submitFormUpdate(modifierId, data, previousModifiers) {
  return {
    type: LIBRARY_MODIFIER_HUB_SUBMIT_FORM_UPDATE,
    payload: { modifierId, data, previousModifiers },
  };
}

export function deleteModifier(modifierId, previousModifiers) {
  return {
    type: LIBRARY_MODIFIER_HUB_DELETE_MODIFIER,
    payload: { modifierId, previousModifiers },
  };
}

export function showDeleteModifierModal() {
  return { type: LIBRARY_MODIFIER_HUB_SHOW_DELETE_MODIFIER_MODAL };
}

export function hideDeleteModifierModal() {
  return { type: LIBRARY_MODIFIER_HUB_HIDE_DELETE_MODIFIER_MODAL };
}

export function setDeletedModifier(deletedModifier) {
  return {
    type: LIBRARY_MODIFIER_HUB_SET_DELETED_MODIFIER,
    payload: { deletedModifier },
  };
}

export function onClickApplySetItem(modifier) {
  return {
    type: LIBRARY_MODIFIER_HUB_ON_CLICK_APPLY_SET_ITEM,
    payload: { modifier },
  };
}

export function onClickApplyAllitem(modifierId) {
  return {
    type: LIBRARY_MODIFIER_HUB_ON_CLICK_APPLY_ALL_ITEMS,
    payload: { modifierId },
  };
}

export function confirmApplySetItem(data, modifierId) {
  return {
    type: LIBRARY_MODIFIER_HUB_CONFIRM_APPLY_SET_ITEM,
    payload: { data, modifierId },
  };
}

export function setModifierApplyAllItems(modifierId) {
  return {
    type: LIBRARY_MODIFIER_HUB_SET_MODIFIER_ALL_ITEMS,
    payload: { modifierId },
  };
}

export function showApplySetItem() {
  return { type: LIBRARY_MODIFIER_HUB_SHOW_APPLY_SET_ITEM_MODAL };
}

export function hideApplySetItemModal() {
  return { type: LIBRARY_MODIFIER_HUB_HIDE_APPLY_SET_ITEM_MODAL };
}

export function applySetItemSetItems(items) {
  return {
    type: LIBRARY_MODIFIER_HUB_APPLY_SET_ITEM_SET_ITEMS,
    payload: { items },
  };
}

export function applySetItemSetMeta(meta) {
  return {
    type: LIBRARY_MODIFIER_HUB_APPLY_SET_ITEM_SET_META,
    payload: { meta },
  };
}

export function showModifierOptionsModal() {
  return { type: LIBRARY_MODIFIER_HUB_SHOW_MODIFIER_OPTIONS_MODAL };
}

export function hideModifierOptionsModal() {
  return { type: LIBRARY_MODIFIER_HUB_HIDE_MODIFIER_OPTIONS_MODAL };
}

export function onClickManageModifierOptions(previousModifierForm) {
  return {
    type: LIBRARY_MODIFIER_HUB_ON_CLICK_MANAGE_MODIFIER_OPTIONS,
    payload: { previousModifierForm },
  };
}

export function onCancelManageModifierOptions(previousModifierForm) {
  return {
    type: LIBRARY_MODIFIER_HUB_ON_CANCEL_MANAGE_MODIFIER_OPTIONS,
    payload: { previousModifierForm },
  };
}

export function onConfirmManageModifierOptions(options) {
  return {
    type: LIBRARY_MODIFIER_HUB_ON_CONFIRM_MANAGE_MODIFIER_OPTIONS,
    payload: { options },
  };
}

export function setPreviousModifierForm(previousModifierForm) {
  return {
    type: LIBRARY_MODIFIER_HUB_SET_PREVIOUS_MODIFIER_FORM,
    payload: { previousModifierForm },
  };
}

export function openRightColumn() {
  return { type: LIBRARY_MODIFIER_HUB_OPEN_RIGHT_COLUMN };
}

export function closeRightColumn() {
  return { type: LIBRARY_MODIFIER_HUB_CLOSE_RIGHT_COLUMN };
}

export function isSubmittingForm(isSubmittingFormPayload) {
  return {
    type: LIBRARY_MODIFIER_HUB_IS_SUBMITTING_FORM,
    payload: { isSubmittingForm: isSubmittingFormPayload },
  };
}

export function openSetAllItemConfirmation() {
  return {
    type: LIBRARY_MODIFIER_HUB_SET_ALL_ITEM_CONFIRMATION_MODAL_OPEN,
  };
}
export function closeSetAllItemConfirmation() {
  return {
    type: LIBRARY_MODIFIER_HUB_SET_ALL_ITEM_CONFIRMATION_MODAL_CLOSE,
  };
}

export function setEventAsyncJob(channelName) {
  return {
    type: LIBRARY_MODIFIER_HUB_SET_CHANNEL_ASYNC_JOB,
    payload: { channelName },
  };
}

export function handleSuccessAsyncJob(resourceId) {
  return {
    type: LIBRARY_MODIFIER_HUB_HANDLE_SUCCESS_ASYNC_JOB,
    payload: { resourceId },
  };
}

export function handleFailedAsyncJob(error) {
  return {
    type: LIBRARY_MODIFIER_HUB_HANDLE_FAILED_ASYNC_JOB,
    payload: { error },
  };
}

export function applySetItemItemsRequest(params, previousItems) {
  return {
    type: LIBRARY_MODIFIER_HUB_APPLY_SET_ITEM_ITEMS_REQUEST,
    payload: { params, previousItems },
  };
}
